// src/hooks/hotelRatings/useForceDeleteHotelRating.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteHotelRating as forceDeleteHotelRatingAPI } from "../../api/apiHotelRatings";
import parseError from "../../utils/parseError";

const useForceDeleteHotelRating = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDelete, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteHotelRatingAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel rating permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete hotel rating");
        },
    });

    return { forceDeleteHotelRating: forceDelete, isForceDelete };
};

export default useForceDeleteHotelRating;
